import React from "react";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import ListOutlinedIcon from "@material-ui/icons/ListOutlined";
import { FbSidebarItem } from "@flexibees/core";
import { Link, useRouteMatch } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as finalCandidateAction from "../actions/finalCandidateAction";

const menuItems = [
  {
    name: "Dashboard",
    icon: HomeOutlinedIcon,
    path: "/dashboard",
  },
  {
    name: "All Projects",
    icon: ListOutlinedIcon,
    path: "/projects",
  },
];

export default function MenuItems() {
  const dispatch = useDispatch(); 
  const [activeMenuIndex, setactiveMenuIndex] = React.useState(
    menuItems.findIndex((mItem) => window.location.href.includes(mItem.path))
  );
  const [activeMenu, setActiveMenu] = React.useState(
    activeMenuIndex < 0 ? "" : menuItems[activeMenuIndex].name
  );

  React.useEffect(() => {
    setactiveMenuIndex(
      menuItems.findIndex((mItem) => window.location.href.includes(mItem.path))
    );
  }, [window.location.href]);

  React.useEffect(() => {
    setActiveMenu(activeMenuIndex < 0 ? "" : menuItems[activeMenuIndex].name);
  }, [activeMenuIndex]);

  const changeActiveMenu = (menu) => {
    setActiveMenu(menu);
    dispatch(finalCandidateAction.resetTableData());
  };

  const { path } = useRouteMatch();

  return (
    <div>
      {menuItems.map((item, index) => {
        return (
          <Link to={`${path}${item.path}`} style={{ textDecoration: "none" }}>
            <FbSidebarItem
              name={item.name}
              icon={item.icon}
              key={index}
              activeMenu={activeMenu}
              changeActiveMenu={changeActiveMenu}
            />
          </Link>
        );
      })}
    </div>
  );
}
